module.exports = __webpack_public_path__ + "f53e48026a1e51c8b5903cde8316b6a9.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/Profile_Pic_Overlay_3.png
// module id = 159
// module chunks = 0